import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, homeFor } from "@/context/Auth";
import { Loading } from "@/components/kit";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import DsaRegister from "@/pages/DsaRegister";
import Apply from "@/pages/Apply";
import Journey from "@/pages/Journey";
import { CustomerHome, Consents, Support } from "@/pages/Portal";
import Dashboard from "@/pages/Dashboard";
import { Leads, LeadDetail } from "@/pages/Leads";
import Kanban from "@/pages/Kanban";
import { Followups, Telecalling } from "@/pages/Calling";
import { Applications, Customers, Tasks, Tickets } from "@/pages/Lists";
import { ImportLeads, Duplicates } from "@/pages/Import";
import { DSAs, Employees, Partners } from "@/pages/People";
import Lenders from "@/pages/Lenders";
import { Payouts, Finance } from "@/pages/Money";
import Reports from "@/pages/Reports";
import AIAssistant from "@/pages/AIAssistant";
import { AuditLogs, Webhooks, Health } from "@/pages/System";
import { SettingsPage, Roles } from "@/pages/Settings";
import Profile from "@/pages/Profile";

function Protected({ children, customer }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (customer !== undefined && (user.role === "customer") !== customer) return <Navigate to={homeFor(user)} replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/partner/register" element={<DsaRegister />} />
          <Route path="/apply/:product" element={<Apply />} />
          <Route element={<Protected customer={true}><AppShell /></Protected>}>
            <Route path="/portal" element={<CustomerHome />} />
            <Route path="/portal/applications/:id" element={<Journey />} />
            <Route path="/portal/consents" element={<Consents />} />
            <Route path="/portal/support" element={<Support />} />
            <Route path="/portal/profile" element={<Profile />} />
          </Route>
          <Route element={<Protected customer={false}><AppShell /></Protected>}>
            <Route path="/crm" element={<Dashboard />} />
            <Route path="/crm/leads" element={<Leads />} />
            <Route path="/crm/leads/:id" element={<LeadDetail />} />
            <Route path="/crm/kanban" element={<Kanban />} />
            <Route path="/crm/followups" element={<Followups />} />
            <Route path="/crm/telecalling" element={<Telecalling />} />
            <Route path="/crm/applications" element={<Applications />} />
            <Route path="/crm/applications/new" element={<Apply staff />} />
            <Route path="/crm/applications/:id" element={<Journey />} />
            <Route path="/crm/tasks" element={<Tasks />} />
            <Route path="/crm/customers" element={<Customers />} />
            <Route path="/crm/import" element={<ImportLeads />} />
            <Route path="/crm/duplicates" element={<Duplicates />} />
            <Route path="/crm/dsa" element={<DSAs />} />
            <Route path="/crm/employees" element={<Employees />} />
            <Route path="/crm/lenders" element={<Lenders />} />
            <Route path="/crm/payouts" element={<Payouts />} />
            <Route path="/crm/finance" element={<Finance />} />
            <Route path="/crm/reports" element={<Reports />} />
            <Route path="/crm/ai" element={<AIAssistant />} />
            <Route path="/crm/tickets" element={<Tickets />} />
            <Route path="/crm/webhooks" element={<Webhooks />} />
            <Route path="/crm/partners" element={<Partners />} />
            <Route path="/crm/audit" element={<AuditLogs />} />
            <Route path="/crm/settings" element={<SettingsPage />} />
            <Route path="/crm/roles" element={<Roles />} />
            <Route path="/crm/health" element={<Health />} />
            <Route path="/crm/profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
